import { useEffect } from 'react';
import { getSchoolProfileRequest } from '../../features/schoolProfile/schoolProfileSlice';
import { useAuth } from '../../hooks/useAuth';
import { useSessionSync } from '../../hooks/useSessionSync';
import MainLayout from '../../layouts/MainLayout';
import AppRoutes from '../../routes/AppRoutes';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchUsersRequest } from '../../features/user/userSlice';
import { checkSessionAPI, refreshTokenAPI } from '../../api/auth/authService';
import { handleLogout } from '../../services/logoutHandler';
import { useCommonFetchInit } from '../../api/commonFetch';
import { useSnackbar } from '../SnackBar/SnackbarContext';
import { ROUTES } from '../../constants/routes';

const AppContent = ({ tenant }) => {
  useCommonFetchInit();
const { user } = useAuth();
const location = useLocation();
const dispatch = useDispatch();
const navigate = useNavigate();
useSessionSync(user);

useEffect(() => {
  if(user == null || user == undefined || location.pathname === ROUTES.ADMINSIGNIN){
    handleLogout(dispatch, user, navigate, "manual", null);
  }
}, [])

useEffect(() => {
  if(user == null || user == undefined){
    navigate(ROUTES.ADMINSIGNIN);
  }
}, [])
  return (
    <>
      <MainLayout tenant={tenant}>
        <AppRoutes />
      </MainLayout>
    </>
  );
};

export default AppContent;
